import { useEffect } from 'react';

import { pushToDataLayer } from 'services/gtmService';

import type { IUseBoostModal } from 'components/Toolkit/BoostModal/types';
import { BOOST_MODAL_GTM_EVENT } from 'components/Toolkit/BoostModal/types';

function useBoostModal({
  isOpen,
  askToClose,
  bumpEligible,
  spotlightEligible,
  section,
  pageType,
  userId,
}: IUseBoostModal) {
  function handleBoostModalClosedPushEvent(product: string) {
    pushToDataLayer({
      event: BOOST_MODAL_GTM_EVENT.BOOST_MODAL_CLOSED,
      selectedProduct: [product],
      contentSharing: [false],
      section: [section],
      pageType: [pageType],
      userId: [userId],
    });
  }

  function handleClose() {
    handleBoostModalClosedPushEvent('none');
    askToClose();
  }
  useEffect(() => {
    if (isOpen) {
      pushToDataLayer({
        event: BOOST_MODAL_GTM_EVENT.BOOST_MODAL_OPEN,
        bumpEligible: [bumpEligible],
        spotlightEligible: [spotlightEligible],
        section: [section],
        pageType: [pageType],
        userId: [userId],
      });
    }
    // TODO: Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, pushToDataLayer]);

  return {
    handleClose,
  };
}

export { useBoostModal };
